import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api";
import { SHOW_COMING_SOON } from "../../config";
import { useSiteContent } from "../../useSiteContent";
import "./Hero.css";
import { motion } from "framer-motion";

export default function Hero() {
    const [user, setUser] = useState(null);
    const [videoBlobUrl, setVideoBlobUrl] = useState(null);
    const videoRef = useRef(null);
    const navigate = useNavigate();
    const { getContent } = useSiteContent();

    useEffect(() => {
        let isMounted = true;
        let createdUrl = null;

        fetch('/assets/gawah_tube.dat')
            .then(res => res.blob())
            .then(rawBlob => {
                if (isMounted) {
                    const videoBlob = new Blob([rawBlob], { type: "video/mp4" });
                    createdUrl = URL.createObjectURL(videoBlob);
                    setVideoBlobUrl(createdUrl);
                }
            })
            .catch(err => console.error("Error loading hero video blob:", err));

        return () => {
            isMounted = false;
            if (createdUrl) {
                URL.revokeObjectURL(createdUrl);
            }
        };
    }, []);

    useEffect(() => {
        if (videoBlobUrl && videoRef.current) {
            const playPromise = videoRef.current.play();
            if (playPromise !== undefined) {
                playPromise.catch(err => {
                    console.log("Hero autoplay prevented by browser:", err);
                });
            }
        }
    }, [videoBlobUrl]);

    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        const token = localStorage.getItem("token");

        if (storedUser) {
            try {
                setUser(JSON.parse(storedUser));
            } catch (e) {
                console.error("Error parsing user:", e);
            }
        }

        if (token) {
            api.get("auth/profile/")
                .then(response => {
                    localStorage.setItem("user", JSON.stringify(response.data));
                    setUser(response.data);
                })
                .catch(err => {
                    console.error("Hero profile sync failed:", err);
                });
        }
    }, []);

    return (
        <section className="hero" id="hero">
            <video
                ref={videoRef}
                className="hero-video-bg"
                autoPlay
                loop
                muted
                playsInline
                controlsList="nodownload"
                poster="/assets/home03.webp"
                src={videoBlobUrl || undefined}
            />

            <motion.div
                className="hero-content"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeOut" }}
            >
                <p className="hero-subtitle">{getContent('hero_subtitle', 'A GLOBAL CHRISTIAN FILM')}</p>
                <h1 className="hero-title">{getContent('hero_title', 'GAWAH')}</h1>
                <div className="hero-witness-container">
                    <span className="witness-line"></span>
                    <h2 className="hero-witness">{getContent('hero_witness', 'Witness')}</h2>
                    <span className="witness-line"></span>
                </div>
                <p className="hero-tagline">{getContent('hero_tagline1', "The story didn't end with Sadhu Sundar Singh.")}</p>
                <p className="hero-tagline hero-tagline-highlight">{getContent('hero_tagline2', "It continued through two ordinary people who chose extraordinary obedience.")}</p>

                <div className="hero-buttons">
                    <button
                        className="btn-hero-filled"
                        onClick={() => document.getElementById('trailer')?.scrollIntoView({ behavior: 'smooth' })}
                    >
                        {getContent('hero_cta_trailer', 'WATCH TRAILER')}
                    </button>
                    {user && user.is_premium ? (
                        <button
                            className="btn-hero-premium-watch"
                            onClick={() => navigate('/watch')}
                        >
                            WATCH PREMIUM CONTENT
                        </button>
                    ) : (
                        <button
                            className="btn-hero-outline"
                            onClick={() => SHOW_COMING_SOON ? navigate('/coming-soon') : document.getElementById('subscribe')?.scrollIntoView({ behavior: 'smooth' })}
                        >
                            {getContent('hero_cta_subscribe', 'SUBSCRIBE FOR FULL MOVIE')}
                        </button>
                    )}
                </div>
            </motion.div>

            <div className="scroll-hint">▼</div>
        </section>
    );
}

